import { eventEmitter } from "../../utils/EventEmitter";
export const portalEventEmitter = eventEmitter();
//# sourceMappingURL=portalEventEmitter.js.map